import { createAction } from 'redux-actions'
import * as constants from './constants'

export const internalSetCMSEnvironment = createAction(constants.SET_CMS_ENVIRONMENT)

export const setCMSEnvironment = environment => {
  sessionStorage.setItem(constants.CMS_ENVIRONMENT_SESSION_STORAGE_KEY, environment)
  return dispatch => dispatch(internalSetCMSEnvironment(environment))
}
